module.exports = __webpack_public_path__ + "static/media/key.6387bd31.svg";